var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIonicinline = function SvgIonicinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#478AFF",
    d: "M1.92 8a6.08 6.08 0 0 1 9.69-4.893 2.3 2.3 0 0 1 1.455-1.3 8 8 0 1 0 2.488 3.55 2.28 2.28 0 0 1-1.719.925A6.08 6.08 0 1 1 1.92 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#478AFF",
    d: "M15.835 6.38a8 8 0 0 0-.282-1.022 2.28 2.28 0 0 1-1.719.924q.173.588.224 1.2a2.5 2.5 0 0 0 1.777-1.103M8 11.5A3.504 3.504 0 0 0 11.5 8 3.504 3.504 0 0 0 8 4.5 3.504 3.504 0 0 0 4.5 8 3.506 3.506 0 0 0 8 11.5M13.25 5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
  })));
};
export default SvgIonicinline;